import { OIDBalanceMemberDetails } from './OIDBalanceMemberDetails';

export default OIDBalanceMemberDetails;
